import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { UnitEventDetails } from '@appTypes/esb';

interface CreateEventState {
  seriesFromEventId?: number;
  baseEvent?: UnitEventDetails;
  hasInviteeChanges: boolean;
  eventToDelete?: { id: number; name: string };
}

const initialState: CreateEventState = {
  seriesFromEventId: undefined,
  baseEvent: undefined,
  hasInviteeChanges: false,
};

export const createEventSlice = createSlice({
  initialState,
  name: 'createEventSlice',
  reducers: {
    resetState: () => initialState,
    setEventSeriesFrom: (
      state,
      action: PayloadAction<{
        eventId: number;
        eventDetails: UnitEventDetails;
      }>,
    ) => {
      const payload = action.payload;
      state.seriesFromEventId = payload.eventId;
      state.baseEvent = payload.eventDetails;
    },
    setHasInviteeChanges: (
      state,
      action: PayloadAction<{
        hasChanges: boolean;
      }>,
    ) => {
      const payload = action.payload;
      state.hasInviteeChanges = payload.hasChanges;
    },
    setEventToDelete: (
      state,
      action: PayloadAction<
        | {
            id: number;
            name: string;
          }
        | undefined
      >,
    ) => {
      state.eventToDelete = action.payload;
    },
  },
});

export const createEventActions = createEventSlice.actions;
export const {
  setEventSeriesFrom,
  setHasInviteeChanges,
  resetState,
  setEventToDelete,
} = createEventSlice.actions;
